import { useSelector } from "react-redux";

const useCurrencyRates = () => {
    const currencyRates = useSelector((state) => state.currencyRates);
    return currencyRates;
};

export default useCurrencyRates;